import api from './api'
import store from '@/store'
import moment from 'moment'
import CallHelper from '@/helpers/call.helper'

class AppointmentService {
    async get(params = {}) {
        return CallHelper.getDataRecursive(
            '/account/' + store.state.account.uuid + '/appointment',
            params,
            (data, response) => {
                if(data['appointments']) {
                    data['appointments'] = [...data['appointments'], ...response.data.appointments]
                } else {
                    data['appointments'] = response.data.appointments
                }
        
                if(data['persons']) {
                    data['persons'] = [...data['persons'], ...response.data.persons]
                } else {
                    data['persons'] = response.data.persons
                }

                return data
            },
        )
    }

    async create(appointment, account) {
        const d = moment(appointment.date)
        return api.post('/account/' + store.state.account.uuid + '/appointment', {
            account_uuid: account,
            date: d.format('YYYY-MM-DD'),
            time: appointment.heure.hours.toString().padStart(2, '0') + ':' + appointment.heure.minutes.toString().padStart(2, '0') + ':00',
            duration: appointment.duration,
            description: appointment.description,
            reason_id: appointment.reason_id,
            place_id: appointment.place_id,
            person_uuid: appointment.person_uuid,
        })
        .then(response => response.data);
    }

    async modify(appointment) {
        if(appointment.date instanceof Date)
        {
            appointment.date = moment(appointment.date).format('YYYY-MM-DD')
        }

        return api
            .patch('/account/' + store.state.account.uuid + '/appointment/' + appointment.id, {
                date: appointment.date,
                time: appointment.heure.hours.toString().padStart(2, '0') + ':' + appointment.heure.minutes.toString().padStart(2, '0') + ':00',
                duration: appointment.duration,
                description: appointment.description,
                reason_id: appointment.reason_id,
                place_id: appointment.place_id,
                person_uuid: appointment.person_uuid,
            })
            .then(response => response.data)
    }

    async delete(appointment) {
        return api.delete('/account/' + store.state.account.uuid + '/appointment/' + appointment.id).then(response => response.data);
    }
}

export default new AppointmentService();
